import Icon from 'components/ui/icon/Icon'
import './style.scss'

function Hero(props) {
    const {
        TITLE,
        UF_CRM_14_WHEN,
        UF_CRM_14_LINKTOSITE,
        UF_CRM_14_1674651814958,
        UF_CRM_14_1674652110046,
        UF_CRM_14_1674651866558,
        BEGINDATE,
        hideEvent ,
    } = props

    return (
        <>
            <div className="content-block">
                <div className="hero">
                    <div className="hero__link ">
                        {UF_CRM_14_LINKTOSITE && (
                            <a target="_blank" href={UF_CRM_14_LINKTOSITE} className="link">
                                <span>Подробнее о мероприятии</span>
                                <Icon name="i-arrow"></Icon>
                            </a>
                        )}
                    </div>
                    <h1 className="hero__title">{TITLE}</h1>
                    {!hideEvent && (
                        <div className="hero__table">
                            <div className="table">
                                <div className="table__item">
                                    <div className="table__th text-small">Дата и время проведения</div>
                                    <div className="table__td">
                                        {BEGINDATE}, <br></br> {UF_CRM_14_WHEN}
                                    </div>
                                </div>
                                <div className="table__item">
                                    <div className="table__th text-small">Место проведения (формат)</div>
                                    <div className="table__td">
                                        {UF_CRM_14_1674651814958} {UF_CRM_14_1674652110046}
                                    </div>
                                </div>
                                <div className="table__item">
                                    <div className="table__th text-small">Условия участия</div>
                                    <div className="table__td">{UF_CRM_14_1674651866558}</div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Hero
